export default {
  buttons: { done: 'Concluído' },
  title: 'Localização',
};
